var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[(_vm.data)?_c('BasicTemplate',{attrs:{"page-id":4}},[_c('Contacts',{attrs:{"info":_vm.data.info,"outlets":_vm.data.outlets,"shops":_vm.data.shops}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }